import { isNotFoundError } from './isNotFoundError';

type EntityQuery = {
  data?: unknown;
  isFetching: boolean;
  error?: unknown;
};

// The four detail pages have to agree on what "the guest asked for something that
// is not there" means, and on the one case that must not be mistaken for it: the
// API failed, so we do not know whether it exists.
export const entityQueryOutcome = ({ data, isFetching, error }: EntityQuery) => {
  const hasFailed = !!error && !isNotFoundError(error);

  return { hasFailed, isMissing: !data && !isFetching && !hasFailed };
};
